import { DealKpiKey, DealKpiOption } from "../models";

export const MAX_SELECTED_DEAL_KPIS = 5;

export const DEAL_KPI_OPTIONS: DealKpiOption[] = [
  {
    key: "targetCloseDate",
    label: "Target close date",
    description: "Expected date the deal will be finalised",
    category: "Dates",
  },
  {
    key: "introductionDate",
    label: "Introduction date",
    description: "Date this deal was introduced",
    category: "Dates",
  },
  {
    key: "createdAt",
    label: "Start date",
    description: "Date this deal was created",
    category: "Dates",
  },
  {
    key: "investmentValue",
    label: "Investment amount",
    description: "Total capital committed to this deal",
    category: "Currency",
  },
  {
    key: "targetReturns",
    label: "Target returns",
    description: "Projected monetary returns for this deal",
    category: "Currency",
  },
  {
    key: "expectedFees",
    label: "Expected fees",
    description: "Expected fees for this deal",
    category: "Currency",
  },
  {
    key: "moneyMultiple",
    label: "Money multiple",
    description: "Projected return as a multiple",
    category: "Multiple",
  },
  {
    key: "projectIrr",
    label: "Predicted IRR",
    description: "Annualised return over the deal lifecycle",
    category: "Percent",
  },
  {
    key: "conversionProbability",
    label: "Conversion probability",
    description: "Estimated likelihood this deal will close",
    category: "Percent",
  },
];

export const DEFAULT_SELECTED_DEAL_KPI_KEYS: DealKpiKey[] = [
  "investmentValue",
  "targetCloseDate",
  "conversionProbability",
  "projectIrr",
  "moneyMultiple",
];
